<template>
  <v-layout>
    <info-bar v-if="isRedslave" />
    <v-main
      class="background"
      :style="
        branding && branding.backgroundImageUrl
          ? {
              backgroundImage: 'url(' + fitImage(branding.backgroundImageUrl, 3840, 2160, '&') + ')'
            }
          : ''
      "
    >
      <b2-b-commerce-hint v-if="isGeneratedDomain" />
      <v-container fluid class="h-screen w-100">
        <portal-paused v-if="branding && branding.isPaused" :branding="branding" />
        <router-view v-else />
      </v-container>
    </v-main>
  </v-layout>
</template>

<script setup lang="ts">
import InfoBar from '@/components/info-bar/InfoBar.vue'
import { fitImage } from '@/helpers'
import B2BCommerceHint from '@/modules/authentication/components/B2BCommerceHint.vue'
import PortalPaused from '@/modules/authentication/components/PortalPaused.vue'
import useAuthentication from '@/modules/authentication/useAuthentication'
import useBranding from '@/modules/portalSettings/useBranding'
import { computed } from 'vue'

const { branding } = useBranding()
const isRedslave = computed(() => useAuthentication().state.value.isRedslave)

const isGeneratedDomain = computed(() => {
  return window.location.hostname.endsWith('systemhaus.shop')
})
</script>

<style lang="scss" scoped>
.background {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
